import { decompressFromUTF16, compressToUTF16 } from 'lz-string'
import { cyrb53 } from './hash';

export function loadFromLocalStorageCompressed<T = any>(key: string): T | null {
    const value = localStorage.getItem(key);
    if (!value) {
        return null;
    }

    const currentHash = Number.parseInt(value.slice(0, 15).trim(), 16);
    const encoded = value.charAt(15) === '1';
    const compressedData = value.slice(16);

    if (cyrb53(value.slice(15)) !== currentHash) {
        return null;
    }

    try {
        const data = decompressFromUTF16(compressedData);
        if (encoded) {
            return JSON.parse(data);
        }

        return data as T;
    } catch (err) {
        console.log(err);
        return null;
    }
}

export function saveToLocalStorageCompressed(key: string, data: any) {
    let encoded = false;
    if (typeof data !== 'string')  {
        data = JSON.stringify(data);
        encoded = true;
    }
    const compressed = compressToUTF16(data);
    const hash = cyrb53((encoded ? '1' : '0') + compressed).toString(16).padEnd(15, ' ');
    localStorage.setItem(key, hash + (encoded ? '1' : '0') + compressed);
}
